export default "__VITE_PUBLIC_ASSET__a2623342__"